import { render, staticRenderFns } from "./acompanhamentoexames.vue?vue&type=template&id=2c805cb7&scoped=true&"
import script from "./acompanhamentoexames.vue?vue&type=script&lang=js&"
export * from "./acompanhamentoexames.vue?vue&type=script&lang=js&"
import style0 from "./acompanhamentoexames.vue?vue&type=style&index=0&id=2c805cb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c805cb7",
  null
  
)

export default component.exports